import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    email: Yup.string().email(schema.isEmail).required(schema.isRequired),
  });
  return valid;
};

export default validationSchema;
